// Mock data for Homebase Clone

export const locations = [
  { id: 'loc-001', name: 'Downtown Cafe', address: '123 Main St, New York, NY 10001', timezone: 'America/New_York' },
  { id: 'loc-002', name: 'Midtown Restaurant', address: '456 5th Ave, New York, NY 10018', timezone: 'America/New_York' },
  { id: 'loc-003', name: 'Brooklyn Bistro', address: '789 Atlantic Ave, Brooklyn, NY 11217', timezone: 'America/New_York' },
];

// Role types:
// - accounting_admin: Can see all salaries, full payroll access
// - admin: Full access except salary visibility for managers
// - manager: Location-specific, can see employee wages but not other manager salaries
// - employee: Personal portal only

export const users = [
  {
    id: 'user-001',
    email: 'admin@company.com',
    name: 'John Admin',
    role: 'accounting_admin', // Can see all salaries
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    locations: ['loc-001', 'loc-002', 'loc-003'],
    department: 'Accounting',
  },
  {
    id: 'user-004',
    email: 'it@company.com',
    name: 'Tom IT Admin',
    role: 'admin', // Cannot see manager salaries
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&crop=face',
    locations: ['loc-001', 'loc-002', 'loc-003'],
    department: 'IT',
  },
  {
    id: 'user-002',
    email: 'manager@downtown.com',
    name: 'Sarah Manager',
    role: 'manager',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
    locations: ['loc-001'],
    managedLocation: 'loc-001',
    salary: 55000, // Annual salary - only visible to accounting_admin
    salaryType: 'annual',
  },
  {
    id: 'user-003',
    email: 'manager@midtown.com',
    name: 'Mike Manager',
    role: 'manager',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    locations: ['loc-002'],
    managedLocation: 'loc-002',
    salary: 52000,
    salaryType: 'annual',
  },
];

export const employees = [
  {
    id: 'emp-001',
    email: 'alice@company.com',
    name: 'Alice Johnson',
    role: 'employee',
    employeeNumber: 'DT-001',
    locationId: 'loc-001',
    position: 'Barista',
    hourlyRate: 18.50,
    phone: '(555) 123-4567',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
    hireDate: '2024-01-15',
    startDate: '2024-01-20',
    status: 'active',
    // Personal Info
    dateOfBirth: '1995-06-15',
    address: '456 Oak Street, Apt 2B, New York, NY 10002',
    emergencyContact: {
      name: 'Robert Johnson',
      relationship: 'Father',
      phone: '(555) 987-6543',
    },
    notes: 'Preferred morning shifts',
  },
  {
    id: 'emp-002',
    email: 'bob@company.com',
    name: 'Bob Smith',
    role: 'employee',
    employeeNumber: 'DT-002',
    locationId: 'loc-001',
    position: 'Cashier',
    hourlyRate: 16.00,
    phone: '(555) 234-5678',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
    hireDate: '2024-02-20',
    startDate: '2024-02-25',
    status: 'active',
    dateOfBirth: '1998-03-22',
    address: '789 Pine Avenue, New York, NY 10003',
    emergencyContact: {
      name: 'Mary Smith',
      relationship: 'Mother',
      phone: '(555) 876-5432',
    },
    notes: '',
  },
  {
    id: 'emp-003',
    email: 'carol@company.com',
    name: 'Carol Williams',
    role: 'employee',
    employeeNumber: 'DT-003',
    locationId: 'loc-001',
    position: 'Server',
    hourlyRate: 12.00,
    phone: '(555) 345-6789',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face',
    hireDate: '2024-03-10',
    startDate: '2024-03-15',
    status: 'active',
    dateOfBirth: '1992-11-08',
    address: '123 Elm Street, Brooklyn, NY 11201',
    emergencyContact: {
      name: 'David Williams',
      relationship: 'Spouse',
      phone: '(555) 765-4321',
    },
    notes: 'Part-time student',
  },
  {
    id: 'emp-004',
    email: 'david@company.com',
    name: 'David Brown',
    role: 'employee',
    employeeNumber: 'MT-001',
    locationId: 'loc-002',
    position: 'Chef',
    hourlyRate: 25.00,
    phone: '(555) 456-7890',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face',
    hireDate: '2023-11-05',
    startDate: '2023-11-10',
    status: 'active',
    dateOfBirth: '1988-07-30',
    address: '567 Maple Drive, Queens, NY 11375',
    emergencyContact: {
      name: 'Lisa Brown',
      relationship: 'Wife',
      phone: '(555) 654-3210',
    },
    notes: 'Lead chef, certified food handler',
  },
  {
    id: 'emp-005',
    email: 'emma@company.com',
    name: 'Emma Davis',
    role: 'employee',
    employeeNumber: 'MT-002',
    locationId: 'loc-002',
    position: 'Server',
    hourlyRate: 14.00,
    phone: '(555) 567-8901',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face',
    hireDate: '2024-01-22',
    startDate: '2024-01-28',
    status: 'active',
    dateOfBirth: '1996-09-14',
    address: '890 Cedar Lane, Bronx, NY 10451',
    emergencyContact: {
      name: 'Patricia Davis',
      relationship: 'Mother',
      phone: '(555) 543-2109',
    },
    notes: '',
  },
  {
    id: 'emp-006',
    email: 'frank@company.com',
    name: 'Frank Wilson',
    role: 'employee',
    employeeNumber: 'BB-001',
    locationId: 'loc-003',
    position: 'Assistant Manager',
    hourlyRate: 22.00,
    phone: '(555) 678-9012',
    avatar: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=100&h=100&fit=crop&crop=face',
    hireDate: '2023-09-15',
    startDate: '2023-09-20',
    status: 'active',
    dateOfBirth: '1990-04-25',
    address: '234 Birch Road, Staten Island, NY 10301',
    emergencyContact: {
      name: 'Grace Wilson',
      relationship: 'Sister',
      phone: '(555) 432-1098',
    },
    notes: 'Key holder, opening/closing duties',
  },
];

// Time Off Requests
export const timeOffRequests = [
  {
    id: 'tor-001',
    employeeId: 'emp-001',
    locationId: 'loc-001',
    type: 'vacation',
    startDate: '2025-07-20',
    endDate: '2025-07-25',
    reason: 'Family vacation to Florida',
    status: 'pending',
    createdAt: '2025-07-10T10:30:00Z',
    reviewedBy: null,
    reviewedAt: null,
    reviewNote: '',
  },
  {
    id: 'tor-002',
    employeeId: 'emp-002',
    locationId: 'loc-001',
    type: 'sick',
    startDate: '2025-07-12',
    endDate: '2025-07-12',
    reason: 'Doctor appointment',
    status: 'approved',
    createdAt: '2025-07-08T14:00:00Z',
    reviewedBy: 'user-002',
    reviewedAt: '2025-07-08T15:30:00Z',
    reviewNote: 'Approved. Get well soon!',
  },
  {
    id: 'tor-003',
    employeeId: 'emp-003',
    locationId: 'loc-001',
    type: 'personal',
    startDate: '2025-07-15',
    endDate: '2025-07-15',
    reason: 'Moving to new apartment',
    status: 'denied',
    createdAt: '2025-07-05T09:00:00Z',
    reviewedBy: 'user-002',
    reviewedAt: '2025-07-06T11:00:00Z',
    reviewNote: 'Unfortunately we are short-staffed that day. Can you reschedule?',
  },
  {
    id: 'tor-004',
    employeeId: 'emp-004',
    locationId: 'loc-002',
    type: 'vacation',
    startDate: '2025-08-01',
    endDate: '2025-08-07',
    reason: 'Annual leave',
    status: 'pending',
    createdAt: '2025-07-11T08:00:00Z',
    reviewedBy: null,
    reviewedAt: null,
    reviewNote: '',
  },
];

// Messages
export const messages = [
  {
    id: 'msg-001',
    locationId: 'loc-001',
    senderId: 'user-002',
    senderName: 'Sarah Manager',
    senderRole: 'manager',
    type: 'announcement',
    subject: 'Schedule Change Next Week',
    content: 'Hi team! Please note that we will be extending hours next Friday due to a private event. Please check your updated schedules.',
    createdAt: '2025-07-10T09:00:00Z',
    readBy: ['emp-001', 'emp-002'],
    isUrgent: false,
  },
  {
    id: 'msg-002',
    locationId: 'loc-001',
    senderId: 'emp-001',
    senderName: 'Alice Johnson',
    senderRole: 'employee',
    type: 'message',
    subject: 'Running Late',
    content: 'Hi, I\'m running about 15 minutes late today due to train delays. Will be there as soon as possible!',
    createdAt: '2025-07-11T08:45:00Z',
    readBy: ['user-002'],
    isUrgent: true,
    replyTo: null,
  },
  {
    id: 'msg-003',
    locationId: 'loc-001',
    senderId: 'user-002',
    senderName: 'Sarah Manager',
    senderRole: 'manager',
    type: 'message',
    subject: 'Re: Running Late',
    content: 'Thanks for letting me know, Alice. No worries, see you soon!',
    createdAt: '2025-07-11T08:50:00Z',
    readBy: ['emp-001'],
    isUrgent: false,
    replyTo: 'msg-002',
  },
  {
    id: 'msg-004',
    locationId: 'loc-001',
    senderId: 'emp-003',
    senderName: 'Carol Williams',
    senderRole: 'employee',
    type: 'callout',
    subject: 'Unable to Work Tomorrow',
    content: 'I\'m sorry but I won\'t be able to come in tomorrow. I have a family emergency. Can someone cover my shift?',
    createdAt: '2025-07-10T20:00:00Z',
    readBy: ['user-002'],
    isUrgent: true,
  },
  {
    id: 'msg-005',
    locationId: 'loc-002',
    senderId: 'user-003',
    senderName: 'Mike Manager',
    senderRole: 'manager',
    type: 'announcement',
    subject: 'New Menu Items Training',
    content: 'Reminder: Training session for new summer menu items this Saturday at 2 PM. Attendance is mandatory.',
    createdAt: '2025-07-09T14:00:00Z',
    readBy: ['emp-004', 'emp-005'],
    isUrgent: false,
  },
];

// Generate time entries for the past 30 days
const generateTimeEntries = () => {
  const entries = [];
  const today = new Date();
  
  employees.forEach((emp) => {
    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      
      if (date.getDay() === 0 || date.getDay() === 6) {
        if (Math.random() > 0.3) continue;
      }
      
      if (Math.random() > 0.85) continue;
      
      const clockIn = new Date(date);
      clockIn.setHours(8 + Math.floor(Math.random() * 3), Math.floor(Math.random() * 60), 0);
      
      const clockOut = new Date(date);
      clockOut.setHours(16 + Math.floor(Math.random() * 3), Math.floor(Math.random() * 60), 0);
      
      const hoursWorked = (clockOut - clockIn) / (1000 * 60 * 60);
      
      entries.push({
        id: `time-${emp.id}-${i}`,
        employeeId: emp.id,
        locationId: emp.locationId,
        date: date.toISOString().split('T')[0],
        clockIn: clockIn.toISOString(),
        clockOut: clockOut.toISOString(),
        hoursWorked: Math.round(hoursWorked * 100) / 100,
        breakMinutes: 30,
        status: 'approved',
        photoIn: Math.random() > 0.5 ? 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=200&h=200&fit=crop' : null,
        photoOut: Math.random() > 0.5 ? 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=200&h=200&fit=crop' : null,
      });
    }
  });
  
  return entries.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const timeEntries = generateTimeEntries();

// Generate schedules for current and next week
const generateSchedules = () => {
  const schedules = [];
  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());
  
  const shiftTypes = [
    { start: '06:00', end: '14:00', name: 'Morning' },
    { start: '10:00', end: '18:00', name: 'Mid' },
    { start: '14:00', end: '22:00', name: 'Evening' },
  ];
  
  employees.forEach((emp) => {
    for (let week = 0; week < 2; week++) {
      for (let day = 0; day < 7; day++) {
        if (Math.random() > 0.7) continue;
        
        const date = new Date(startOfWeek);
        date.setDate(startOfWeek.getDate() + (week * 7) + day);
        
        const shift = shiftTypes[Math.floor(Math.random() * shiftTypes.length)];
        
        schedules.push({
          id: `sched-${emp.id}-${week}-${day}`,
          employeeId: emp.id,
          locationId: emp.locationId,
          date: date.toISOString().split('T')[0],
          startTime: shift.start,
          endTime: shift.end,
          shiftName: shift.name,
          status: 'scheduled',
          notes: '',
        });
      }
    }
  });
  
  return schedules.sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const schedules = generateSchedules();

// Audit Log
export const auditLogs = [];

export const addAuditLog = (action, entityType, entityId, changes, userId, userName) => {
  const log = {
    id: `audit-${Date.now()}`,
    timestamp: new Date().toISOString(),
    action,
    entityType,
    entityId,
    changes,
    userId,
    userName,
  };
  auditLogs.unshift(log);
  return log;
};

// Check if user can view salaries
export const canViewSalaries = (user) => {
  return user?.role === 'accounting_admin';
};

// Check if user can view manager salaries specifically
export const canViewManagerSalaries = (user) => {
  return user?.role === 'accounting_admin';
};

// Calculate payroll summary
export const calculatePayrollSummary = (locationId, period = 'weekly', includeManagerSalaries = false) => {
  const today = new Date();
  let startDate, endDate;
  
  switch (period) {
    case 'daily':
      startDate = new Date(today);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(today);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'weekly':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay());
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'monthly':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    case 'annual':
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
      break;
    default:
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 7);
      endDate = today;
  }
  
  const relevantEntries = timeEntries.filter((entry) => {
    const entryDate = new Date(entry.date);
    const matchesLocation = locationId === 'all' || entry.locationId === locationId;
    return matchesLocation && entryDate >= startDate && entryDate <= endDate;
  });
  
  const employeePayroll = {};
  
  relevantEntries.forEach((entry) => {
    const emp = employees.find((e) => e.id === entry.employeeId);
    if (!emp) return;
    
    if (!employeePayroll[entry.employeeId]) {
      employeePayroll[entry.employeeId] = {
        employee: emp,
        totalHours: 0,
        regularHours: 0,
        overtimeHours: 0,
        totalPay: 0,
      };
    }
    
    employeePayroll[entry.employeeId].totalHours += entry.hoursWorked;
  });
  
  Object.values(employeePayroll).forEach((record) => {
    const weeklyLimit = 40;
    if (record.totalHours > weeklyLimit) {
      record.regularHours = weeklyLimit;
      record.overtimeHours = record.totalHours - weeklyLimit;
    } else {
      record.regularHours = record.totalHours;
      record.overtimeHours = 0;
    }
    
    const regularPay = record.regularHours * record.employee.hourlyRate;
    const overtimePay = record.overtimeHours * record.employee.hourlyRate * 1.5;
    record.totalPay = Math.round((regularPay + overtimePay) * 100) / 100;
  });
  
  // Calculate manager salaries if includeManagerSalaries is true
  let managerPayroll = [];
  if (includeManagerSalaries) {
    const relevantManagers = users.filter(u => 
      u.role === 'manager' && 
      u.salary && 
      (locationId === 'all' || u.managedLocation === locationId)
    );
    
    managerPayroll = relevantManagers.map(mgr => {
      let periodSalary = 0;
      switch (period) {
        case 'daily':
          periodSalary = mgr.salary / 365;
          break;
        case 'weekly':
          periodSalary = mgr.salary / 52;
          break;
        case 'monthly':
          periodSalary = mgr.salary / 12;
          break;
        case 'annual':
          periodSalary = mgr.salary;
          break;
        default:
          periodSalary = mgr.salary / 52;
      }
      return {
        manager: mgr,
        salary: mgr.salary,
        periodSalary: Math.round(periodSalary * 100) / 100,
      };
    });
  }
  
  const summary = {
    period,
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
    totalHours: Object.values(employeePayroll).reduce((sum, r) => sum + r.totalHours, 0),
    totalCost: Object.values(employeePayroll).reduce((sum, r) => sum + r.totalPay, 0),
    employeeBreakdown: Object.values(employeePayroll),
    managerPayroll,
    totalManagerCost: managerPayroll.reduce((sum, m) => sum + m.periodSalary, 0),
  };
  
  return summary;
};

// Calculate payroll for single employee
export const calculateEmployeePayroll = (employeeId, period = 'weekly') => {
  const today = new Date();
  let startDate, endDate;
  
  switch (period) {
    case 'daily':
      startDate = new Date(today);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(today);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'weekly':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay());
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'monthly':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    case 'annual':
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
      break;
    default:
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 7);
      endDate = today;
  }
  
  const employee = employees.find(e => e.id === employeeId);
  if (!employee) return null;
  
  const relevantEntries = timeEntries.filter((entry) => {
    const entryDate = new Date(entry.date);
    return entry.employeeId === employeeId && entryDate >= startDate && entryDate <= endDate;
  });
  
  const totalHours = relevantEntries.reduce((sum, e) => sum + e.hoursWorked, 0);
  const weeklyLimit = 40;
  const regularHours = Math.min(totalHours, weeklyLimit);
  const overtimeHours = Math.max(0, totalHours - weeklyLimit);
  const regularPay = regularHours * employee.hourlyRate;
  const overtimePay = overtimeHours * employee.hourlyRate * 1.5;
  const totalPay = Math.round((regularPay + overtimePay) * 100) / 100;
  
  return {
    period,
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
    employee,
    totalHours: Math.round(totalHours * 100) / 100,
    regularHours: Math.round(regularHours * 100) / 100,
    overtimeHours: Math.round(overtimeHours * 100) / 100,
    totalPay,
    entries: relevantEntries,
  };
};

export const getLocationPrefix = (locationId) => {
  const prefixes = {
    'loc-001': 'DT',
    'loc-002': 'MT',
    'loc-003': 'BB',
  };
  return prefixes[locationId] || 'EMP';
};

export const generateEmployeeNumber = (locationId) => {
  const prefix = getLocationPrefix(locationId);
  const locationEmployees = employees.filter((e) => e.locationId === locationId);
  const nextNumber = String(locationEmployees.length + 1).padStart(3, '0');
  return `${prefix}-${nextNumber}`;
};
